import { AwsUi } from '../../../../core/runtime/src';
import BemClassBuilder from '../../../../core/utils/src/class-builders/bem';
import { Button } from '../../../button/src';
import { DrawerButton, ResizeHandle } from './primitives';
export var TOOLS_DRAWER_ID = 'awsui-internal-tools';
export function DrawerContent(_a) {
    var activeDrawer = _a.activeDrawer, isHidden = _a.isHidden, isMobile = _a.isMobile, onClose = _a.onClose;
    var _b, _c, _d, _e, _f;
    return (AwsUi.__createElement("aside", { className: "awsui-app-layout__drawer-content", "aria-label": (_c = (_b = activeDrawer) === null || _b === void 0 ? void 0 : _b.ariaLabels.content, (_c !== null && _c !== void 0 ? _c : '')), hidden: activeDrawer && !isHidden ? null : 'true', "aria-hidden": activeDrawer && !isHidden ? 'false' : 'true' },
        ((_d = activeDrawer) === null || _d === void 0 ? void 0 : _d.resizable) && !isMobile ? AwsUi.__createElement(ResizeHandle, null) : null,
        AwsUi.__createElement(Button, { label: (_f = (_e = activeDrawer) === null || _e === void 0 ? void 0 : _e.ariaLabels.closeButton, (_f !== null && _f !== void 0 ? _f : '')), className: "awsui-app-layout__close-button", variant: "icon", click: onClose, icon: "close", formAction: "none" }),
        activeDrawer && !isHidden ? activeDrawer.content : AwsUi.__createElement("span", null)));
}
export function DesktopDrawersBar(_a) {
    var drawers = _a.drawers, onToggle = _a.onToggle, activeDrawerId = _a.activeDrawerId;
    return (AwsUi.__createElement("aside", { className: "awsui-app-layout__drawer awsui-app-layout__drawer--multiple" }, drawers.map(function (drawer) {
        var className = new BemClassBuilder({ __componentName: 'awsui-app-layout' }, 'drawer-button')
            .modifier('desktop')
            .modifier('active', drawer.id === activeDrawerId)
            .toString();
        if (drawer.id === TOOLS_DRAWER_ID) {
            className += ' awsui-app-layout__toggle--tools';
        }
        return AwsUi.__createElement(DrawerButton, { className: className, drawer: drawer, onToggle: onToggle });
    })));
}
export function MobileDrawersBar(_a) {
    var drawers = _a.drawers, onToggle = _a.onToggle;
    return (AwsUi.__createElement("aside", { className: new BemClassBuilder({ __componentName: 'awsui-app-layout' }, 'toggle-landmark')
            .modifier('drawers')
            .toString() }, drawers.map(function (drawer) {
        var className = new BemClassBuilder({ __componentName: 'awsui-app-layout' }, 'drawer-button')
            .modifier('mobile')
            .toString();
        if (drawer.id === TOOLS_DRAWER_ID) {
            className += ' awsui-app-layout__toggle--tools-mobile';
        }
        return AwsUi.__createElement(DrawerButton, { className: className, drawer: drawer, onToggle: onToggle });
    })));
}
//# sourceMappingURL=index.js.map